import { useState } from "react";
import { toast } from "react-toastify";
import { IoIosArrowRoundBack } from "react-icons/io";

import axios from "axios";
import { useNavigate } from "react-router-dom";
axios.defaults.baseURL = "https://fullstack-node-app.vercel.app/";
axios.defaults.headers.common["Authorization"] =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRlbW9AZ21haWwuY29tIiwiaWF0IjoxNjc2NDkzNTI4fQ.VNWQDQJM9jDXrGofVLk3brpqlcNwFzjDmLLwfP9Rw4TM20IIuayvzubPJPfrkJb4kcRAUchdg7uy36rf9z-n9eLdcCw6FQLBBP7t0IA0NhFwjc0NjsJ50zUFgqPi8TAeVclD3DpjEoIRGbSrJpeVIBnLy6DeY7NcugJRbzKpW7iVq9WR9hO-mJ9n01zzEs3xJZ9Kyvq0dir680qPAtEdqLIvPstK8tDRNoYwcZXUthxSoDEAf-sp-E1qbuVv1WDlNpmBncWcUKFUgxeAuoFKRaYOy-9xrATE33C3wUW26Q9nUWJjDHiDw_Oe695P1UpTsKntGAWI_ECytTZhlA_pug";

const AddProduct = () => {
  const [product, setProduct] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addProduct(product);
  };

  const addProduct = async (product) => {
    try {
      const res = await axios.post("/products", product);
      toast.success("Added", res);
      navigate("/");

      setProduct({});
    } catch (error) {
      toast.error("Error adding product:", error);
    }
  };

  return (
    <>
      <div className="min-h-screen items-center justify-center bg-gray-200">
        <div className="flex items-center w-full justify-center">
          <a
            href="/"
            className="text-4xl text-white bg-indigo-600 rounded-md shadow-md"
          >
            <IoIosArrowRoundBack />
          </a>
          <h1 className="text-3xl text-center p-4 font-semibold ">
            Enter Product
          </h1>
        </div>
        <form
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 m-8 grid md:grid-cols-2 h-full"
          onSubmit={handleSubmit}
        >
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="title"
            >
              Title
            </label>
            <input
              id="title"
              name="title"
              type="text"
              placeholder="Title"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            />
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="description"
            >
              Description
            </label>
            <input
              id="description"
              name="description"
              type="text"
              placeholder="Description"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            />
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="thumbnail"
            >
              Thumbnail
            </label>
            <input
              id="thumbnail"
              name="thumbnail"
              type="text"
              placeholder="Thumbnail"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            />
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="price"
            >
              Price
            </label>
            <input
              id="price"
              name="price"
              type="number"
              placeholder="Price"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            />
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="category"
            >
              Category
            </label>
            <select
              id="category"
              name="category"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            >
              <option value="">Choose</option>
              <option value="smartphone">Smartphone</option>
              <option value="laptops">Laptop</option>
              <option value="desktop">Desktop</option>
              <option value="accessories">Accessories</option>
              <option value="others">Others</option>
            </select>
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="brand"
            >
              Brand
            </label>
            <select
              id="brand"
              name="brand"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            >
              <option value="">Choose</option>
              <option value="apple">Apple</option>
              <option value="samsung">Samsung</option>
              <option value="acer">Acer</option>
              <option value="asus">Asus</option>
              <option value="xiaomi">Xiaomi</option>
              <option value="others">Others</option>
            </select>
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="discountPercentage"
            >
              Discount Percentage
            </label>
            <input
              id="discountPercentage"
              name="discountPercentage"
              type="number"
              placeholder="Discount Percentage"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            />
          </div>
          <div className="m-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="rating"
            >
              Rating
            </label>
            <input
              id="rating"
              name="rating"
              type="number"
              placeholder="Ratings"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              required
            />
          </div>
          <div className="m-4">
            <button
              type="submit"
              className="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Add Product
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddProduct;
